import { useSelector } from 'react-redux';
import { APPLICATION_TYPE } from '../constants/sessionStorage';
import { selectApplication } from '../store/selectors/applicationSelectors';
import { retrieveFromSessionStorage } from '../util/helpers/sessionStorageHelper';

export const useAccountData = () => {
  const ApplicationType = retrieveFromSessionStorage(APPLICATION_TYPE);
  const Application = useSelector(selectApplication);
  const AccountData = Application[ApplicationType];

  return AccountData;
};
